export const SET_PROFILE = "user/set_profile";
